var $1f0dc3b9307be026$exports = {};
(function() {
    document.documentElement.style.setProperty('--vh', `${window.innerHeight / 100}px`);
})();
function $1f0dc3b9307be026$var$setDocHeight() {
    document.documentElement.style.setProperty('--vh', `${window.innerHeight / 100}px`);
}
addEventListener('resize', $1f0dc3b9307be026$var$setDocHeight);
addEventListener('orientationchange', $1f0dc3b9307be026$var$setDocHeight);
$1f0dc3b9307be026$var$setDocHeight();


//# sourceMappingURL=en-run.75f534fc.js.map
